import { I18n } from "@lingui/core";

import {
  CountryCodes,
  CountryCodeSupported,
  countryCodeToName,
} from "src/common/country";
import { Currency } from "src/common/currencies";
import { Country } from "src/config";

export const additionalCurrencies: Record<Currency, Country> = {
  [Currency.Gbp]: {
    code: CountryCodes.GB,
    name: "United Kingdom",
  },
  [Currency.Eur]: {
    name: "Eurozone",
  },
  [Currency.Usd]: {
    code: CountryCodes.US,
    name: "United States",
  },
  [Currency.Aud]: {
    code: CountryCodes.AU,
    name: "Australia",
  },
  [Currency.Nzd]: {
    code: CountryCodes.NZ,
    name: "New Zealand",
  },
  [Currency.Sek]: {
    code: CountryCodes.SE,
    name: "Sweden",
  },
  [Currency.Dkk]: {
    code: CountryCodes.DK,
    name: "Denmark",
  },
  [Currency.Cad]: {
    code: CountryCodes.CA,
    name: "Canada",
  },
};

// The constraints at the moment are:
// - AU bank accounts can only be used in BECS
// - ZA bank accounts can not be used in any of the current schemes
// - Betallingservice is only enabled on DK bank accounts
// - NZ bank accounts are only enabled for BECS_NZ
// - CA bank accounts are only enabled for PAD
// - US bank accounts are only enabled for ACH
//
// So instead of listing all the country codes for each currency,
// we filter them according to these exceptions.
export const countryCodesPerCurrency = (i18n: I18n) => {
  const sortedCountryCodes = Object.keys(CountryCodeSupported).sort((a, b) =>
    countryCodeToName(i18n)[a as CountryCodes].localeCompare(
      countryCodeToName(i18n)[b as CountryCodes]
    )
  );

  return {
    GBP: sortedCountryCodes.filter(
      (code) => !["NZ", "CA", "AU", "US"].includes(code)
    ),
    EUR: sortedCountryCodes.filter(
      (code) => !["NZ", "CA", "AU", "US", "ZA"].includes(code)
    ),
    SEK: sortedCountryCodes.filter(
      (code) => !["NZ", "CA", "AU", "US"].includes(code)
    ),
    AUD: sortedCountryCodes.filter(
      (code) => !["NZ", "CA", "US"].includes(code)
    ),
    DKK: sortedCountryCodes.filter((code) => code === "DK"),
    NZD: sortedCountryCodes.filter((code) => code === "NZ"),
    CAD: sortedCountryCodes.filter((code) => code === "CA"),
    USD: sortedCountryCodes.filter((code) => code === "US"),
  };
};

export const eurozoneCountries: CountryCodes[] = [
  CountryCodes.AT,
  CountryCodes.BE,
  // Croatia HR?
  CountryCodes.CY,
  CountryCodes.EE,
  CountryCodes.FI,
  CountryCodes.FR,
  CountryCodes.DE,
  CountryCodes.GR,
  CountryCodes.IE,
  CountryCodes.IT,
  CountryCodes.LV,
  CountryCodes.LT,
  CountryCodes.LU,
  CountryCodes.MT,
  CountryCodes.NL,
  CountryCodes.PT,
  CountryCodes.SK,
  CountryCodes.SI,
];
